export function countAllNestedItems (item) {
  let count = 0

  function recurse (node) {
    if (Array.isArray(node)) {
      // If it's an array, iterate over each element and recurse
      node.forEach(element => recurse(element))
    } else if (typeof node === 'object' && node !== null) {
      count++ // Count the current parent object
      for (const key in node) {
        recurse(node[key]) // Recurse into its children
      }
    } else if (typeof node === 'string') {
      count++ // Count the string (leaf node)
    }
  }

  recurse(item) // Start the recursion

  return count
}

export function generateRandomId () {
  return 'id-' + Math.random().toString(36).substr(2, 9)
}

export function composeUrlFromArray (parts) {
  return `/${parts.filter(Boolean).join('/')}`
}

export function sleep (ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function pluralize (count, word) {
  return count > 1 ? `${word}s` : word
}

export function capitalize (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function getCookiesWithPrefix (prefix) {
  if (!document?.cookie) {
    return []
  }

  const cookieNames = document.cookie.split(/=[^;]*(?:;\s*|$)/)

  return cookieNames
    .filter(name => name.startsWith(prefix))
}

/**
 * Converts API errors to user-friendly messages
 * @param {Error} err - The error object
 * @param {string} fallback - Fallback message if no specific error found
 * @returns {string} User-friendly error message
 */
export function getErrorMessage (err, fallback = 'Something went wrong') {
  // Handle different error types
  if (err.response?.status) {
    const status = err.response.status
    const data = err.response.data

    // Server returned specific error message
    if (data?.message) {
      return data.message
    }

    // Handle specific HTTP status codes
    switch (status) {
      case 400:
        return 'Invalid request. Please check your input and try again.'
      case 401:
        return 'You are not authorized to perform this action.'
      case 403:
        return 'You do not have permission to access this resource.'
      case 404:
        return 'The requested resource was not found.'
      case 422:
        return 'The data you provided is invalid. Please check and try again.'
      case 500:
        return 'Server error occurred. Please try again later.'
      case 503:
        return 'Service temporarily unavailable. Please try again later.'
      default:
        return `Request failed with status ${status}. Please try again.`
    }
  }

  // Network or other errors
  if (err.code === 'NETWORK_ERROR' || err.message?.includes('Network Error')) {
    return 'Network error. Please check your connection and try again.'
  }

  if (err.message?.includes('timeout')) {
    return 'Request timed out. Please try again.'
  }

  // Return the original message if it's user-friendly, otherwise use fallback
  return err.message || fallback
}
